import React from "react";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation("app");

  return (
    <div className="not-found-coming-soon">
      <p>{t("notFound")}</p>
    </div>
  );
};

export default NotFound;
